import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const SellerEditProducts = () => {
  const [products, setProducts] = useState([]);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({});
  const [images, setImages] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      const token = localStorage.getItem('token');
      const { data } = await api.get('products/seller/mine', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProducts(data);
    };
    fetchProducts();
  }, []);

  const startEdit = (product) => {
    setEditing(product._id);
    setFormData({ ...product, recipes: product.recipes?.join('\n') || '' });
    setImages([]);
  };

  const cancelEdit = () => {
    setEditing(null);
    setFormData({});
    setImages([]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setImages(e.target.files);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    const data = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (key === 'recipes') {
        value.split('\n').forEach((r) => data.append('recipes', r));
      } else {
        data.append(key, value);
      }
    });
    for (let i = 0; i < images.length; i++) {
      data.append('images', images[i]);
    }

    await api.put(`products/${editing}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });

    setEditing(null);
    window.location.reload();
  };

  return (
    <div className="container mt-5">
      <h2 className="text-success mb-4 fw-bold">Edit Your Products</h2>
      {products.map((p) => (
        <div key={p._id} className="card shadow-sm mb-4 border border-success">
          <div className="card-body">
            {editing === p._id ? (
              <form onSubmit={handleUpdate} encType="multipart/form-data">
                {['name', 'description', 'price', 'category', 'stock'].map((field) => (
                  <div className="mb-3" key={field}>
                    <label className="form-label text-success fw-semibold">
                      {field.charAt(0).toUpperCase() + field.slice(1)}
                    </label>
                    <input
                      className="form-control"
                      name={field}
                      value={formData[field]}
                      onChange={handleChange}
                      required
                    />
                  </div>
                ))}
                <div className="mb-3">
                  <label className="form-label text-success fw-semibold">Recipes</label>
                  <textarea
                    className="form-control"
                    name="recipes"
                    rows="3"
                    value={formData.recipes}
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label text-success fw-semibold">Upload New Images</label>
                  <input type="file" multiple className="form-control" onChange={handleFileChange} />
                </div>
                <div className="d-flex justify-content-end">
                  <button type="submit" className="btn btn-success me-2">Save</button>
                  <button type="button" className="btn btn-outline-secondary" onClick={cancelEdit}>Cancel</button>
                </div>
              </form>
            ) : (
              <>
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="text-success fw-bold">{p.name}</h5>
                  <button className="btn btn-outline-success" onClick={() => startEdit(p)}>Edit</button>
                </div>
                <p className="mb-1"><strong>Description:</strong> {p.description}</p>
                <p className="mb-1"><strong>Category:</strong> {p.category}</p>
                <p className="mb-1"><strong>Price:</strong> €{p.price}</p>
                <p className="mb-1"><strong>Stock:</strong> {p.stock}</p>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SellerEditProducts;
